import cloneDeep from 'lodash/cloneDeep';

class RequestConfig {
    constructor(newConfig) {
        this.rawConfig = newConfig;
    }

    /**
     *
     * @param value
     */
    set rawConfig(value) {
        const rawConfig = cloneDeep(value);

        this._rawConfig = {
            ...this.defaultConfig(),
            ...rawConfig
        };

        this._xhrLib = this._rawConfig.xhrLib;
        this._apiHost = this._rawConfig.apiHost;
        this._apiVersion = this._rawConfig.apiVersion;
        this._apiPrefix = this._rawConfig.apiPrefix;
    }

    /**
     *
     * @returns {*}
     */
    get xhrLib() {
        return this._xhrLib;
    }

    /**
     *
     * @param value
     */
    set xhrLib(value) {
        this._xhrLib = value;
    }

    /**
     * @returns {string}
     */
    get apiVersion() {
        return this._apiVersion;
    }

    /**
     * @param value
     */
    set apiVersion(value) {
        this._apiVersion = value;
    }

    /**
     * @returns {*}
     */
    get apiPrefix() {
        return this._apiPrefix;
    }

    /**
     * @param value
     */
    set apiPrefix(value) {
        this._apiPrefix = value;
    }

    /**
     * @returns {*|null}
     */
    get apiHost() {
        return this._apiHost;
    }

    /**
     * @param newConfig
     */
    set(newConfig) {
        this.rawConfig = newConfig;
    }

    /**
     * @returns {{apiVersion: string, apiPrefix: string, apiHost: null}}
     */
    defaultConfig() {
        const defaults = {
            apiVersion: 'v1',
            apiPrefix: 'api',
            apiHost: 'http://localhost',
            xhrLib: null,
        };
        for (let param in defaults) {
            if (!defaults.hasOwnProperty(param)) {
                continue;
            }
            if (typeof this[param] !== 'undefined') {
                defaults[param] = this[param];
            }
        }
        return defaults;
    }

    /**
     * @param path
     * @returns {string}
     */
    apiUrl(path) {
        let envHost = this.apiHost;

        let apiUrl = envHost === null ? '' : envHost +
            '/' + this.apiPrefix +
            '/' + this.apiVersion;

        if (typeof path === 'string') {
            apiUrl = apiUrl + '/' + path;
        }

        return apiUrl;
    }
}

const requestConfig = new RequestConfig();

export default requestConfig;
